import Swal, { SweetAlertIcon } from 'sweetalert2';
import './estilo.css';
import { deleteRol, deleteToken, deleteUserData } from '../api/Account';

export const simpleMessage = (text: string, icon?: SweetAlertIcon): void => {
	Swal.fire({
		title: text,
		icon: icon,
		customClass: { container: 'my-swal', popup: 'border' }
	});
};

export const completeMessage = (title: string, text: string, icon?: SweetAlertIcon): void => {
	Swal.fire(title, text, icon);
};

export const oSVersion = (): string => {
	let OSName = 'Unknown OS';
	if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'WINDOWS';
	if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MACOS';
	if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
	if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'LINUX';
	return OSName;
};

export const navigatorVersion = (): string | undefined => {
	let sBrowser: string | undefined;
	const sUsrAg = navigator.userAgent;
	if (sUsrAg.indexOf('Edg') > -1) {
		sBrowser = 'Microsoft Edge';
	} else if (sUsrAg.indexOf('Chrome') > -1) {
		sBrowser = 'Google Chrome';
	} else if (sUsrAg.indexOf('Safari') > -1) {
		sBrowser = 'Apple Safari';
	} else if (sUsrAg.indexOf('Opera') > -1) {
		sBrowser = 'Opera';
	} else if (sUsrAg.indexOf('Firefox') > -1) {
		sBrowser = 'Mozilla Firefox';
	} else if (sUsrAg.indexOf('MSIE') > -1) {
		sBrowser = 'Microsoft Internet Explorer';
	}

	return sBrowser;
};

export function validateCedula(cedula: string): boolean {
	const re = new RegExp('^[0-9]{3}-[0-9]{6}-[0-9]{4}[A-Za-z]$');
	return re.test(cedula);
}

interface AccessPermission {
	description: string;
	isEnable: boolean;
}

export function isAccess(access: AccessPermission[] = [], permiso: string): boolean {
	const found = access.find((a) => a.description === permiso);
	return Boolean(found?.isEnable);
}

export const getUserLocation = async (): Promise<[number, number]> => {
	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			({ coords }) => {
				resolve([coords.longitude, coords.latitude]);
			},
			(err) => {
				console.log('No se pudo obtener Localizacion');
				console.log(err);
				reject();
			}
		);
	});
};

export const getRuta = (): string => {
	const { REACT_APP_ROUTE, REACT_APP_PROD_ROUTE } = process.env;
	let ruta = '';
	if (process.env.NODE_ENV === 'production') {
		ruta = REACT_APP_PROD_ROUTE || '';
	} else {
		ruta = REACT_APP_ROUTE || '';
	}
	return ruta;
};

export const guid = (): string => {
	return 'yxyx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

export const getController = (): string => {
	let ruta = '';
	if (process.env.NODE_ENV === 'production') {
		ruta = 'https://www.inver-credit.net/';
	} else {
		ruta = 'https://localhost:44460/';
	}
	return ruta;
};

interface ErrorResponseObj {
	status: number;
	data?: {
		message?: string;
	};
}

export const errorResponse = (response: ErrorResponseObj): string | undefined => {
	if (response.status === 401) {
		deleteToken();
		deleteUserData();
		deleteRol();
		return 'Unauthorized';
	} else if (response.status === 400) {
		if (response.data?.message === 'eX01') {
			deleteToken();
			deleteUserData();
			deleteRol();
			return 'Sesión activa en otro dispositivo';
		} else {
			return response.data?.message;
		}
	} else if (response.status === 403) {
		return response.data?.message ?? 'No tiene permisos para realizar esta acción';
	} else if (response.status === 404) {
		return response.data?.message ?? 'Recurso no Encontrado';
	} else if (response.status === 500) {
		return response.data?.message ?? 'Error de Servidor';
	} else if (response.status === 0) {
		return 'No se pudo conectar con el servidor';
	} else {
		return response.data?.message ?? 'Ocurrió un error inesperado';
	}
};

export const formatCurrency = (amount: number): string => {
	return new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' }).format(amount);
};

export const generarNuevoColor = (): string => {
	const simbolos = '0123456789ABCDEF';
	let color = '#';

	for (let i = 0; i < 6; i++) {
		color = color + simbolos[Math.floor(Math.random() * 16)];
	}

	return color;
};

export const calculoSeguro = (monto: number): number => {
	if (monto <= 5000) {
		return 150;
	} else if (monto > 5000 && monto <= 10000) {
		return 200;
	} else {
		return 250;
	}
};
